import { ref, onMounted, onBeforeUnmount } from 'vue';

// Measure the live height of `targetRef` (a template ref to an element) and
// return a reactive pixel value suitable for feeding into a sibling sticky
// element's `top` style. Re-measures on resize so wrapping filter rows
// don't desync the offset.
export function useStickyOffset(targetRef) {
  const height = ref(0);
  let ro = null;

  function measure() {
    const el = targetRef.value;
    if (el) height.value = Math.round(el.getBoundingClientRect().height);
  }

  onMounted(() => {
    measure();
    if (typeof ResizeObserver !== 'undefined' && targetRef.value) {
      ro = new ResizeObserver(measure);
      ro.observe(targetRef.value);
    }
    window.addEventListener('resize', measure);
  });

  onBeforeUnmount(() => {
    if (ro) ro.disconnect();
    window.removeEventListener('resize', measure);
  });

  return height;
}
